<template>
  <div id="chart"></div>
</template>

<script>
import echarts from 'echarts'
import { getDataCommon } from "common/js/http/v3Api";
export default {
  props: {
    row: Object,
    country: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      id: 'F03_01_02_01_C',
      pagesize: '365',
      clientHeight: '',
      other: '2019999000000013',
      forexData: [],
      chart: null,
      legendLabel: '',
      lineData: [],
      seriesData: [],
      unit: ''
    }
  },
  watch: {
    row(n, o) {
      // this.getDMData(this.row)
      this.getDataCommon()
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    async getDataCommon() {
      const { data } = await getDataCommon({
        'fcode': 'F03_01_02_01_C',
        'countryCode': this.country.countryCode,
        'pagesize': this.pagesize,
        't': new Date().getTime(),
        'other': this.row.codeId,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' })
      let tmpData = data.result.data
      if (tmpData != null && tmpData.length !== 0) {
        this.legendLabel = tmpData[0].LABEL_CODE
        this.seriesData = tmpData[0].bid1.split(',').map(item => item.replace(/\'/g, ''))
        this.lineData = tmpData[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
        this.initChart()
      }
    },
    initChart() {
      var option = {
        title: {
          textStyle: {
            color: '#4c5e70',
            fontSize: '17',
            fontWeight: 400
          }
        },
        color: ['#3fb1e3', '#cc70af', '#ffb980', '#9b8bba',
          '#e098c7', '#97b552', '#d87a80', '#eedd78',
          '#2ec7c9', '#626c91', '#cbb0e3', '#73a373', '#8dc1a9',
          '#97d4dc', '#82c0c9', '#b7dba1', '#a0a7e6', '#6be6c1'],
        grid: {
          x: 0,
          y: 10,
          x2: 15,
          y2: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#9ca0a9',
          axisPointer: {
            type: 'line',
            lineStyle: {
              width: '0.5',
              type: 'dashed'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'line'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.lineData,
            axisTick: {
              show: true,
              lineStyle: {
                color: '#DFE1E5'
              }
            },
            axisLine: { show: false }
          }
        ],
        dataZoom: [
          {
            type: 'slider', // 图表下方的伸缩条
            show: true,  // 是否显示
            realtime: true,  //
            start: 80,  // 伸缩条开始位置（1-100），可以随时更改
            end: 100,  // 伸缩条结束位置（1-100），可以随时更改
            bottom: 10,
            height: 20
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            boundaryGap: [0.1, 0.1],
            axisTick: {
              show: false
            },
            axisLine: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#dfe1e5']
              }
            }
          }
        ],
        series: [
          {
            name: this.legendLabel,
            type: 'line',
            data: this.seriesData,
            showSymbol: false,
            symbolSize: 0.5,
            symbol: 'circle',
            areaStyle: { normal: {} }
          }
        ]
      }
      this.chart = echarts.init(document.getElementById('chart'))
      this.chart.setOption(option)
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    }
  }
}
</script>

<style scoped lang="scss">
#chart {
  width: 100%;
  height: 35vh;
}
.el-table__empty-text {
  color: #fff0 !important;
}
.el-loading-spinner .path {
  stroke: #fff0;
}
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.66);
}
</style>
